import { PartialServiceModel, SpeedtestState, createNqError } from "@visonum/network-quality-sdk";

export enum PartialServiceCases {
    Default = "Default",
    FirstStartResultIsNotOkInterfaceHasErrors = "FirstStartResultIsNotOkInterfaceHasErrors",   // Case 1
    FirstStartResultIsOkInterfaceHasManyErrors = "FirstStartResultIsOkInterfaceHasManyErrors", // Case 2
    FirstStartCase3 = "FirstStartCase3",                                                       // Case 3
    AgainResultIsNotOkInterfaceHasManyErrors = "AgainResultIsNotOkInterfaceHasManyErrors",     // Case 6
}

/* pure */
export const getIsFirstRun = (days: number | null) => days === null || days > 2;

/* pure */
export const calcPartialServiceCase = (modemResetDays: number | null, speedtestState: SpeedtestState, partialServiceModel: PartialServiceModel, callbackCounter: number, currentDownloadSpeed: number, bookedDownloadSpeedMax: number | null): PartialServiceCases => {

    if (modemResetDays !== null && modemResetDays < 0) {
        throw createNqError("Cl-9-130", `modemResetDays less than 0 (${modemResetDays})`);
    }

    const downloadIndex = partialServiceModel.downloadIndex;
    const uploadIndex = partialServiceModel.uploadIndex;

    if (downloadIndex === null || uploadIndex === null) {
        return PartialServiceCases.Default;
    }

    if (downloadIndex < 0) {
        throw createNqError("Cl-10-130", `downloadIndex less than 0 (${downloadIndex})`);
    }

    if (uploadIndex < 0) {
        throw createNqError("Cl-11-130", `uploadIndex less than 0 (${downloadIndex})`);
    }

    const firstRun = getIsFirstRun(modemResetDays);
    const downIsOk = speedtestState.downloadUdp === null ? speedtestState.downloadClient : speedtestState.downloadUdp;
    const upIsOk = speedtestState.uploadClient
    const udpIsOk = speedtestState.downloadUdp === true && bookedDownloadSpeedMax !== null;

    if (firstRun) {
        // Case 1, Case 2
        if ((modemResetDays === null || modemResetDays > 30)) {
            // Case 1
            if (!downIsOk && downloadIndex > 0 || !upIsOk && uploadIndex > 0) {
                return PartialServiceCases.FirstStartResultIsNotOkInterfaceHasErrors;
            }

            // Case 2
            if (downIsOk && downloadIndex >= 10 || upIsOk && uploadIndex >= 4) {
                return PartialServiceCases.FirstStartResultIsOkInterfaceHasManyErrors;
            }
        } else {
            // Case 3
            if (!downIsOk && downloadIndex > 0 || !upIsOk && uploadIndex > 0 ||
                downIsOk && downloadIndex >= 10 || upIsOk && uploadIndex >= 4) {
                return PartialServiceCases.FirstStartCase3;
            }
        }
    } else {
        // Case 6
        if ((!downIsOk && downloadIndex >= 10 ||
            udpIsOk && currentDownloadSpeed <= 0.3 * bookedDownloadSpeedMax && downloadIndex >= 10 ||
            !upIsOk && uploadIndex >= 4) 
            && callbackCounter > 0) {
            return PartialServiceCases.AgainResultIsNotOkInterfaceHasManyErrors;
        }
    }

    return PartialServiceCases.Default;
}